<template>
  <div class="header">
    <v-landing-container class="header__container">
      <div class="logo">
        <img src="/logo.svg" :title="$t('v.home.serviceName')" :alt="$t('v.home.serviceName')" />
      </div>
      <a
        :href="yandexLink"
        class="button button-circle"
        :disabled="loading"
      >Начать работу</a>
    </v-landing-container>
  </div>
</template>

<script>
import * as type from '@/store/types'
import VLandingContainer from '@/components/Landing/VLandingContainer.vue'

export default {
  name: 'Header',
  components: { VLandingContainer },
  data() {
    return {
      yandexLink: `https://oauth.yandex.ru/authorize?response_type=
code&client_id=3a7d6ddb33dc4ae4be1fad72401d2149&redirect_uri=${document.location.origin}/`
    }
  },

  computed: {
    loading() {
      return this.$store.state[type.SESSION].loading
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/scss/vars";
@import "../../../assets/style/scss/extends";

.header {
  @extend %flex-column;
  background-color: $white;
  width: 100%;
  align-items: center;
  z-index: 10;
}

.header__container {
  padding: 24px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header__link {
  margin: 0 10px;
  text-decoration: underline;
}
</style>
